export enum PromptModel {
  // TODO: These lint rules are excessive
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_35_TURBO = 'GPT_35_TURBO',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4 = 'GPT_4',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4_TURBO = 'GPT_4_TURBO',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4o = 'GPT_4o',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4o_MINI = 'GPT_4o_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4_1 = 'GPT_4_1',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4_1_MINI = 'GPT_4_1_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_4_1_NANO = 'GPT_4_1_NANO',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  O1 = 'O1',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  O1_MINI = 'O1_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  O3 = 'O3',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  O3_MINI = 'O3_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  O4_MINI = 'O4_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5 = 'GPT_5',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_1 = 'GPT_5_1',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_MINI = 'GPT_5_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_NANO = 'GPT_5_NANO',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_2 = 'GPT_5_2',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_4 = 'GPT_5_4',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_4_MINI = 'GPT_5_4_MINI',
  // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums, @typescript-eslint/naming-convention
  GPT_5_5 = 'GPT_5_5',
}

export const DefaultModel = PromptModel.GPT_5_MINI;

export enum PromptsVersion {
  V2 = '2',
}

export enum PromptScopeType {
  Automatic = 'AUTOMATIC',
  Document = 'DOCUMENT',
  DocumentSpecial = 'DOCUMENT_SPECIAL',
  Passage = 'PASSAGE',
  Word = 'WORD',
}

export enum PromptType {
  // word and phrase level prompts
  Define = 'DEFINE',
  EncyclopediaLookup = 'LOOKUP',
  TermLookup = 'TERM_LOOKUP',
  // passage level prompts
  Flashcard = 'FLASHCARD',
  PermanentNote = 'PERMANENT_NOTE',
  Simplify = 'SIMPLIFY',
  // document level prompts
  GenerateQuestions = 'GENERATE_QUESTIONS',
  WriteReview = 'WRITE_REVIEW',
  // generic
  Ask = 'ASK',
  HighlightDocument = 'HIGHLIGHT_DOCUMENT',
  SummarizeDocument = 'SUMMARIZE_DOCUMENT',
  TagDocument = 'TAG_DOCUMENT',
  Translate = 'TRANSLATE',
  // custom
  Custom = 'CUSTOM',
  Generic = 'GENERIC',
}

export enum PromptReturnType {
  Text = 'TEXT',
  List = 'LIST',
}

export enum PromptResponseAction {
  // Note: this is no longer accurate. In Ghostreader chat, it's a chat message response
  AppendToNote = 'APPEND_TO_NOTE',
  CreateTags = 'CREATE_TAGS',
  CreateHighlights = 'CREATE_HIGHLIGHTS',
  UpdateSummary = 'UPDATE_SUMMARY',
}
